import {
  ICollector,
  ISearchCollectorReq,
  ISearchCollectorRes,
  IUpdatePaymentReceived,
  IUploadPaymentRecieved,
} from '../interfaces/collector';
import * as baseAdapter from './baseAdapter';

export const getOrder = async (id: number) => {
  const ret = await baseAdapter.get<ICollector>('/collector/get/' + id);
  return ret?.data;
};

export const searchCollectors = async (req: ISearchCollectorReq) => {
  const ret = await baseAdapter.post<ISearchCollectorRes>(
    '/collector/gets',
    req,
  );
  return ret;
};

export const addCollector = async (data: Partial<ICollector>) => {
  const ret = await baseAdapter.post<ICollector>('/collector/create', data);
  return ret;
};

export const deleteCollector = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/collector/delete/${id}`);
  return ret;
};

export const uploadPaymentReceived = async (data: IUploadPaymentRecieved) => {
  const ret = await baseAdapter.post<boolean>(
    `/collector/updatePaymentReceived`,
    data,
  );
  return ret;
};

export const updatePaymentReceived = async (data: IUpdatePaymentReceived) => {
  const ret = await baseAdapter.post<boolean>(`/collector/updatePayment`, data);
  return ret;
};
